import AsyncContent from './AsyncContent';

export default AsyncContent;



// WEBPACK FOOTER //
// ./src/views/components/AsyncContent/index.js